<header class="header" [ngClass]="{'theme-cities': isCityPage}">

  @if (showTitle) {
  <div class="header-text">
    <h1>CERTIFICADO DE TRADICIÓN Y LIBERTAD</h1>
  </div>
  }

  <nav class="navigator">

    @if(!isMobile){
    <button class="nav-burger-btn" (click)="toggleMenuCities()">
      <img height="24" width="24" src="assets/icons/unicolor/menu-burger-white.svg" alt="Icono de menú para ciudades" />
    </button>
    }

    <button class="menu-toggle" type="button" (click)="toggleMenu()" aria-label="Abrir/Cerrar menú">
      <img height="24" width="24" src="assets/icons/unicolor/menu-burger-white.svg" alt="Icono de menú" />
    </button>

    @if (showMenu || showMenuCities) {
    <div class="menu-backdrop" (click)="closeMenu()"></div>
    }

    @if(showMenuCities){
    <div class="cities-menu-container">

      <div class="menu-open">
        <ul>
          <li>
            <a href="/validar-certificado/" (click)="closeAllMenus()">
              Validar Certificado
            </a>
          </li>
          <li>
            <a href="/leer-certificado-tradicion-y-libertad/" (click)="closeAllMenus()">
              ¿Cómo leer el certificado de tradición y libertad?
              <img height="24" width="24" src="assets/icons/unicolor/chevron-right-white.svg" alt="Icono de flecha" />
            </a>
          </li>

          <li>
            <a href="/directorio/" (click)="closeAllMenus()">
              Directorio de oficinas de registro
            </a>
          </li>
          @for (key of cityKeys; track key) {
          <li>
            <a [href]="cities[key].url" (click)="closeAllMenus()">
              Certificado de Tradición y Libertad {{ cities[key].displayName }}
            </a>
          </li>
          }
        </ul>
      </div>

      <button class="menu-close-cities" (click)="closeAllMenus()" aria-label="Cerrar menú">&times;</button>

    </div>
    }

    <ul [ngClass]="{ 'hiddenMenu': !showMenu }">
      <li style="border: none; height: 0; padding: 0; margin: 0;">
        <button class="menu-close" (click)="closeAllMenus()" aria-label="Cerrar menú">&times;</button>
      </li>

      @if (!showCitiesMenu) {
      <li>
        <a href="/" (click)="closeAllMenus()">
          Comprar Certificado de Tradición y Libertad
        </a>
      </li>
      <li>
        <a href="/redimir-codigo/" (click)="closeAllMenus()">
          Redimir código
        </a>
      </li>
      <li>
        <a href="/consulta-tu-matricula/" (click)="closeAllMenus()">
          Consulta tu matrícula
        </a>
      </li>
      <li>
        <a href="/recuperar-certificado/" (click)="closeAllMenus()">
          Recuperar Certificado
        </a>
      </li>
      @if(isMobile){
      <li>
        <a href="/validar-certificado/" (click)="closeAllMenus()">
          Validar Certificado
        </a>
      </li>
      <li>
        <a href="/leer-certificado-tradicion-y-libertad/" (click)="closeAllMenus()">
          ¿Cómo leer el certificado de tradición y libertad?
        </a>
      </li>
      <li>
        <a href="/directorio/" (click)="closeAllMenus()">
          Directorio de oficinas de registro
        </a>
      </li>
      }
      <li>
        <a href="/preguntas-frecuentes/" (click)="closeAllMenus()">
          Preguntas frecuentes
        </a>
      </li>
      <li>
        <a href="/blog/" target="_self" (click)="closeAllMenus()">
          Blog
        </a>
      </li>
      @if(isMobile){
      <li>
        <span (click)="toggleCitiesMenu()"> Certificado de Tradición
          <img height="24" width="24" src="assets/icons/unicolor/chevron-right-white.svg" alt="Icono de flecha" />
        </span>
      </li>
      }
      }

      @if (isMobile && showCitiesMenu) {
      <li>
        <span (click)="toggleCitiesMenu()" class="cities-back-span"> <img height="24" width="24"
            src="assets/icons/unicolor/chevron-right-white.svg" alt="Icono de volver" class="icon-rotate-180" />
          <strong>Volver al menú</strong>
        </span>
      </li>
      @for (key of cityKeys; track key) {
      <li>
        <a [href]="cities[key].url" (click)="closeAllMenus()">
          Certificado de Tradición y Libertad {{ cities[key].displayName }}
        </a>
      </li>
      }
      }

    </ul>
  </nav>
</header>